// @flow

<template>
  <tr @click="navigateToDetails">
    <td class="order_date">{{ order.orderDate | dateFormat }}</td>
    <td class="id">{{ order.id }}</td>
    <td class="contract_number">{{ order.contractNumber ? order.contractNumber.number : '' }}</td>
    <td class="order_type">{{ $t(`generic.orderType.${order.orderType}`) }}</td>
    <td class="status">{{ $t(`generic.status.${order.status}`) }}</td>
  </tr>
</template>

<script>
import customFilters from '../../filters'

export default {
  name: 'OrderListItem',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      filters: {
        dateFormat: customFilters.dateFormat
      }
    }
  },
  methods: {
    navigateToDetails () {
      this.$router.push({name: 'order-details', params: {orderId: this.order.id}})
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/orders/OrderListItem.vue